import { IProfileOptionsResponse } from '@kcftech/prometheustypescriptapiclient';
import { Control, Controller } from 'react-hook-form';

import { ProfileItem, ProfileSettingDropdown, ProfileSubSection } from '../components';
import { UserSettingsFormData } from './UserProfileModal';

export type OtherIndicatorOptionsPaneProps = Readonly<{
    options: IProfileOptionsResponse;
    className?: string;
    control: Control<UserSettingsFormData>;
}>;

export function OtherIndicatorOptionsPane({
    options: { PressureUnits, TemperatureUnits },
    className,
    control,
}: OtherIndicatorOptionsPaneProps) {
    return (
        <ProfileSubSection className={className} title="Other Indicator Units">
            <ProfileItem label="Temperature Units">
                <Controller
                    control={control}
                    name="profile.TemperatureUnits"
                    render={({ field: { onChange, value } }) => (
                        <ProfileSettingDropdown
                            options={TemperatureUnits}
                            value={
                                TemperatureUnits.find(
                                    (option) => option.Value === value
                                ) ?? TemperatureUnits[0]
                            }
                            onConfirm={(value) => onChange(value?.Value)}
                        />
                    )}
                />
            </ProfileItem>
            <ProfileItem label="Pressure Units">
                <Controller
                    control={control}
                    name="profile.PressureUnits"
                    render={({ field: { onChange, value } }) => (
                        <ProfileSettingDropdown
                            options={PressureUnits}
                            value={
                                PressureUnits.find((option) => option.Value === value) ??
                                PressureUnits[0]
                            }
                            onConfirm={(value) => onChange(value?.Value)}
                        />
                    )}
                />
            </ProfileItem>
        </ProfileSubSection>
    );
}
